// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__92bY6","line":"Logo_line__ap7is"};